import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { ChevronUp, ChevronDown, Trash2, Plus, X } from "lucide-react";
import CommentEditor from "./CommentEditor";

export default function QuestionCard({
  question, index, isFirst, isLast,
  onChangeType, onUpdate, onMove, onRemove,
  onAddOption, onUpdateOption, onRemoveOption,
}) {
  const q = question;

  return (
    <div className="border border-black/15 p-4 space-y-3" data-testid={`question-card-${index}`}>
      <div className="flex items-center justify-between gap-2">
        <Select value={q.type} onValueChange={(val) => onChangeType(q.id, val)}>
          <SelectTrigger className="h-8 w-36 rounded-none border-black/15 text-xs">
            <SelectValue />
          </SelectTrigger>
          <SelectContent className="rounded-none">
            <SelectItem value="rating">Rating</SelectItem>
            <SelectItem value="yesno">Yes-No</SelectItem>
            <SelectItem value="choice">Choice</SelectItem>
            <SelectItem value="text">Text</SelectItem>
          </SelectContent>
        </Select>
        <div className="flex items-center gap-1">
          <button
            type="button"
            onClick={() => onMove(q.id, -1)}
            disabled={isFirst}
            className="p-1 text-[#525252] hover:text-[var(--brand)] disabled:opacity-30"
          >
            <ChevronUp className="w-4 h-4" />
          </button>
          <button
            type="button"
            onClick={() => onMove(q.id, 1)}
            disabled={isLast}
            className="p-1 text-[#525252] hover:text-[var(--brand)] disabled:opacity-30"
          >
            <ChevronDown className="w-4 h-4" />
          </button>
          <button
            type="button"
            onClick={() => onRemove(q.id)}
            className="p-1 text-[#525252] hover:text-red-600"
          >
            <Trash2 className="w-4 h-4" />
          </button>
        </div>
      </div>

      <Input
        placeholder="Question title"
        value={q.title}
        onChange={(e) => onUpdate(q.id, { title: e.target.value })}
        className="h-9 rounded-none border-black/20 bg-transparent text-sm"
      />
      <Input
        placeholder="Subtitle (optional)"
        value={q.subtitle || ""}
        onChange={(e) => onUpdate(q.id, { subtitle: e.target.value })}
        className="h-9 rounded-none border-black/20 bg-transparent text-sm"
      />

      {q.type === "text" && (
        <Input
          placeholder="Placeholder text (optional)"
          value={q.placeholder || ""}
          onChange={(e) => onUpdate(q.id, { placeholder: e.target.value })}
          className="h-9 rounded-none border-black/20 bg-transparent text-sm"
        />
      )}

      {q.type === "choice" && (
        <div className="space-y-2">
          <Label className="text-[10px] uppercase tracking-widest text-[#525252]">Options</Label>
          {(q.options || []).map((opt, optIdx) => (
            <div key={optIdx} className="flex items-center gap-2">
              <Input
                value={opt}
                onChange={(e) => onUpdateOption(q.id, optIdx, e.target.value)}
                className="h-8 rounded-none border-black/20 bg-transparent text-sm flex-1"
              />
              <button
                type="button"
                onClick={() => onRemoveOption(q.id, optIdx)}
                disabled={q.options.length <= 2}
                className="p-1 text-[#525252] hover:text-red-600 disabled:opacity-30"
              >
                <X className="w-4 h-4" />
              </button>
            </div>
          ))}
          <Button
            variant="outline"
            size="sm"
            onClick={() => onAddOption(q.id)}
            className="rounded-none border-black/15 text-xs uppercase tracking-wider"
          >
            <Plus className="w-3 h-3" /> Add Option
          </Button>
        </div>
      )}

      {q.type === "yesno" && (
        <CommentEditor
          comment={q.comment}
          onChange={(comment) => onUpdate(q.id, { comment })}
        />
      )}

      <div className="flex items-center justify-between border-t border-black/10 pt-3">
        <Label className="text-[10px] uppercase tracking-widest text-[#525252]">Required</Label>
        <Switch
          checked={Boolean(q.required)}
          onCheckedChange={(checked) => onUpdate(q.id, { required: checked })}
        />
      </div>
    </div>
  );
}
